import { Card, CardContent, Chip, Typography } from "@mui/material";
import { useStyle } from "./style";
import { useTranslation } from "react-i18next";

interface IParams {
    description: string;
}

export const OngoingAddonStatus = (props: IParams) => {
    const { description } = props;
    const { classes } = useStyle({});
    const { t } = useTranslation("addons");

    return (
        <Card className={classes.addonStatusContainer} elevation={0}>
            <CardContent className={classes.addonStatusInnerContainer}>
                <Chip className={classes.addonStatusLabel} label={t("inProgress")} />
                <Typography color="secondary" variant="small">
                    {t("onItsWay", { description })}
                </Typography>
            </CardContent>
        </Card>
    );
};
